import React, { useEffect, useState } from 'react';
import { requiredUpdateForPassenger, startRequiredUpdate } from '../utils/requiredUpdate';
import { useLanguage } from '../i18n/LanguageContext';

// This is deliberately a gate, rather than a browser alert: alerts can be
// dismissed with Android back and would leave an obsolete binary operating.
// It is mounted only outside active rides and the booking flow (App + Book).
export default function RequiredUpdateGate({ notice, activeRide, bookingFlowActive }) {
  const { t } = useLanguage();
  const [update, setUpdate] = useState(null);
  const [openingPlay, setOpeningPlay] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (activeRide || bookingFlowActive) {
      setUpdate(null);
      return () => { cancelled = true; };
    }
    requiredUpdateForPassenger(notice)
      .then((next) => { if (!cancelled) setUpdate(next); })
      .catch(() => { if (!cancelled) setUpdate(null); });
    return () => { cancelled = true; };
  }, [notice, activeRide?.id, bookingFlowActive]);

  if (!update) return null;

  const openUpdate = async () => {
    setOpeningPlay(true);
    await startRequiredUpdate();
    // Keep the gate visible if Play has not yet made the release available.
    // The next app start re-checks the installed version from native code.
    setOpeningPlay(false);
  };

  return (
    <div className="required-update-gate" role="dialog" aria-modal="true" aria-labelledby="required-update-title">
      <section className="required-update-card">
        <div className="required-update-icon" aria-hidden="true">↑</div>
        <span className="required-update-eyebrow">MYTOWNLY RIDES</span>
        <h1 id="required-update-title">{update.title}</h1>
        <p>{update.message}</p>
        <div className="required-update-version">
          {t('requiredUpdate.versionLine', { version: update.minimumVersion })}
        </div>
        <button type="button" className="btn btn-primary required-update-button" onClick={openUpdate} disabled={openingPlay}>
          {openingPlay ? t('requiredUpdate.opening') : t('requiredUpdate.updateNow')}
        </button>
        <small>{t('requiredUpdate.idleNote')}</small>
      </section>
    </div>
  );
}
